module.exports = __webpack_public_path__ + "static/img/icon-introduction.597a7387.png";